import React, { FC, useCallback } from "react";
import { connect } from "react-redux";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import User from "@mapmycustomers/shared/types/User";

import UserMultiSelectField from "@app/component/input/UserMultiSelectField";
import RoundButton from "@app/component/RoundButton";
import { getUsers } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./CreatorFilter.module.scss";

type OwnerFilterProps = {
  label?: string;
  onChange: (userIds: User["id"][]) => void;
  selectedUserIds: User["id"][];
} & ReturnType<typeof mapStateToProps>;

const CreatorFilter: FC<OwnerFilterProps> = ({ label, onChange, selectedUserIds, users }) => {
  const intl = useIntl();
  const analytics = useAnalytics();

  const handleClick = useCallback(() => {
    analytics.clicked(["Owner"]);
  }, [analytics]);

  return (
    <Popover
      content={
        <div className={styles.creatorsSelect}>
          <UserMultiSelectField
            allowClear
            onChange={onChange}
            users={users}
            value={selectedUserIds}
          />
        </div>
      }
      placement="bottom"
      trigger={["click"]}
    >
      <RoundButton
        active={selectedUserIds.length > 0}
        onClick={handleClick}
        rightIcon={<FontAwesomeIcon icon={faAngleDown} />}
      >
        {label ??
          intl.formatMessage({
            id: "filters.creatorFilter.creator",
            defaultMessage: "Creator",
            description: "Creator filter",
          })}
      </RoundButton>
    </Popover>
  );
};

const mapStateToProps = (state: RootState) => ({
  users: getUsers(state),
});

export default connect(mapStateToProps)(CreatorFilter);
